module.exports = __webpack_public_path__ + "static/media/dot_FC4491.a9ed478b.svg";